import { render, staticRenderFns } from "./CASEBlobItem.vue?vue&type=template&id=5406fd4c&"
import script from "./CASEBlobItem.vue?vue&type=script&lang=js&"
export * from "./CASEBlobItem.vue?vue&type=script&lang=js&"
import style0 from "./CASEBlobItem.vue?vue&type=style&index=0&id=5406fd4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VHover,VIcon})
